<template>
  <base-layout :do-skip-header="false" :doSkipPic="shouldSkipPic">
    <template #main>
      <div class="flex justify-between items-center mb-10 sm:mb-2">
        <h1 class="text-3xl md:text-4xl font-bold mt-8">
            Scheduler
        </h1>

        <button
            @click="exportMeetings()"
            class="mt-8 flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-3 sm:px-4 py-2 rounded-md"
            title="Export Meetings"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>

            <span class="hidden sm:inline">Export Meetings</span>
        </button>
      </div>
      <div v-show="captainsDinnerRegistrationStatus === 1" class="text-red-600 mt-2 ">
        Reminder: You are registered for the Captain's Dinner on Thursday October 22 at 19:00
      </div>
      <div v-if="isLoaded" class="mt-4">
        <div class="sm:hidden">
          <label for="tabs" class="sr-only">Select a day</label>
          <select v-model="currentTab"
            class="block w-full rounded-md border-gray-300 focus:border-red-500 focus:ring-red-500 text-sm">
            <!-- <option :key="0" :value="0">{{ formatDay(days[0]) }}</option>
            <option :key="1" :value="1">{{ formatDay(days[1]) }}</option> -->
            <option :key="0" :value="0">Thursday Oct 22</option>
            <option :key="1" :value="1">Friday Oct 23</option>
            <option :key="2" :value="2">Cancelled Meetings</option>
          </select>
        </div>
        <div class="hidden sm:block">
          <div class="border-b border-gray-200">
            <nav class="-mb-px flex space-x-8" aria-label="Tabs">
              <!-- <button :class="tabClass('0')" @click="currentTab = '0'">{{ formatDay(days[0]) }}</button>
              <button :class="tabClass('1')" @click="currentTab = '1'">{{ formatDay(days[1]) }}</button> -->
              <button :class="tabClass('0')" @click="currentTab = '0'">Thursday Oct 22</button>
              <button :class="tabClass('1')" @click="currentTab = '1'">Friday Oct 23</button>
              <button :class="tabClass('2')" @click="currentTab = '2'">Cancelled Meetings</button>
            </nav>
          </div>
        </div>
        <div v-if="currentTab === '0' || currentTab === '1'">
          <div class="flex justify-end w-full mt-3">
            <div class="w-full sm:w-64">
              <select v-model="statusFilter" id="status-filter" name="status"
                class="block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm text-gray-700">
                <option value="All">All time slots</option>
                <option value="Available">Available time slots</option>
                <option value="Pending">Requests</option>
                <option value="Confirmed">Confirmed Meetings</option>
                <option value="Blocked">Blocked time slots</option>
                <option v-if="attendeeCount > 1" value="AllMeetings">Company Meetings</option>
              </select>
            </div>
          </div>
          <div class="grid grid-cols-1 gap-4 md:grid-cols-2 mt-3">
            
            <div v-for="timeslot in currentTimeslots" :key="timeslot.id"
              class="relative items-center space-x-3 rounded-xl shadow-sm focus-within:ring-2 focus-within:ring-red-500 focus-within:ring-offset-2 border hover:shadow-xl bg-white"
              :class="timeslot.cssContainer">
              <div v-if="statusFilter === 'AllMeetings'">
                <a href="javascript:void(0)" class="focus:outline-none text-sm">
                  <div class="w-full h-12 text-white rounded-t-lg flex justify-between items-center bg-emerald-500">
                    <p class="mx-3 uppercase">{{ timeslot.timeStart }} - {{ timeslot.timeEnd }}</p>
                  </div>
                  <div class="px-4 py-5">
                    <div class=" h-auto items-center">
                      
                      <!-- Legend -->
                        <div class="flex flex-row-reverse flex-wrap items-center gap-x-4 gap-y-2 text-xs text-gray-600 mb-6">
                           
                          <div class="flex items-center">
                              <span class="inline-block w-3 h-3 rounded-full bg-blue-500 mr-1"></span>
                              Available
                          </div>
                          
                          <div class="flex items-center">
                            <span class="inline-block w-3 h-3 rounded-full bg-red-500 mr-1"></span>
                            Pending
                          </div>
                          <div class="flex items-center">
                            <span class="inline-block w-3 h-3 rounded-full bg-green-500 mr-1"></span>
                            Confirmed
                          </div>
                        </div>
                      <div>
                        <div
                          v-for="c in timeslot.contacts
                            .slice()
                            .sort((a, b) => {
                              const priority = c => {
                                if (c.meetingstatus === 1) return 0
                                if (c.meetingstatus === 0) return 1
                                return 2
                              }

                              return priority(a) - priority(b) ||
                                a.contactName.localeCompare(b.contactName)
                            })"
                          :key="c.id"
                          class="mb-1 text-sm"
                        >
                          <span
                            class="inline-block w-2 h-2 rounded-full mr-2 flex-shrink-0"
                            :class="
                              c.meetingstatus === 1
                                ? 'bg-green-500'
                                : c.meetingstatus === 0
                                  ? 'bg-red-500'
                                  : 'bg-blue-500'
                            "
                          ></span>
                          <span v-if="c.showTableLabel" class=" font-bold">{{ c.table }} : </span>
                          {{ c.display }}
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              
              <div v-else>
                <a href="javascript:void(0)" class="focus:outline-none text-sm">
                  <div class="w-full h-12 text-white rounded-t-lg flex justify-between items-center"
                    :class="timeslot.cssHeading">
                    <p class="font-black mx-3 uppercase">
                      {{
                        timeslot.state === 'accepted'
                          ? 'CONFIRMED' : timeslot.state === 'fullyBooked'
                            ? 'FULLY BOOKED' : timeslot.state
                      }}
                    </p>
                    <p class="mx-3 uppercase">{{ timeslot.timeStart }} - {{ timeslot.timeEnd }}
                      <span v-if="timeslot.table">| {{ timeslot.table }}</span>
                    </p>
                  </div>
                  <div class="px-4 py-5">
                    <div class="mb-4 h-auto sm:h-[145px] items-center">
                      <div v-if="timeslot.state === 'pending' || timeslot.state === 'accepted'"
                        class="relative flex flex-col md:flex-row md:items-start gap-1">

                        <!-- Meeting details -->
                        <div class="min-w-0 flex-1 order-1 md:order-1">
                          <div
                            class='text-lg md:text-2xl font-black text-gray-500 overflow-hidden break-all break-words'>
                            {{ timeslot.meet.contact.name }}</div>
                          <div class="overflow-hidden break-all break-words">
                            {{ timeslot.meet.contact.companyName }}
                            <span v-if="timeslot.meet.contact.function">| {{ timeslot.meet.contact.function }}</span>
                          </div>

                          <div class="mt-2 space-y-1">
                            <!-- Website -->
                            <div class="overflow-hidden break-words">
                              <span class="inline-flex items-start space-x-2">
                                <!-- <i class="fa-solid fa-up-right-from-square text-gray-800"></i> -->
                                <a :href="timeslot.meet.contact.website.startsWith('http') || timeslot.meet.contact.website.startsWith('https://')
                                  ? timeslot.meet.contact.website : 'https://' + timeslot.meet.contact.website"
                                  target="_blank" class="break-all text-red-600">
                                  {{ timeslot.meet.contact.website }}
                                </a>

                              </span>
                            </div>

                            <!-- Email -->
                            <div v-if="!timeslot.meet.contact.email">
                              <span>N/A</span>
                            </div>
                            <div v-else>
                              <!-- <i class="fa-solid fa-envelope text-gray-800 mr-2"></i> -->
                              <a :href="timeslot.meet.contact.mailLink" class="break-all text-red-600">
                                {{ timeslot.meet.contact.email }}
                              </a>
                            </div>

                            <!-- Telephone -->
                            <div v-if="timeslot.meet.contact.tel">
                              <!-- <i class="fa-solid fa-phone text-gray-800 mr-2"></i> -->
                              <a :href="timeslot.meet.contact.telLink" class="text-red-600">
                                {{ timeslot.meet.contact.tel }}
                              </a>
                            </div>

                          </div>
                        </div>

                        <!-- Check-in + profiles (mobile: 1 row with badge left, profiles right) -->
                        <div class="w-full order-2 md:order-2 md:w-auto flex flex-col md:items-end">
                          <div
                            class="flex items-center justify-between w-full md:flex-col md:items-end md:justify-start">

                            <!-- Check-in status on the left (mobile) / top (desktop) -->
                            <div v-if="timeslot.meet.contact.isCheckedIn"
                              class="mr-4 md:mr-0 mt-0 md:mt-2 px-3 py-1 inline-flex text-xs items-center font-bold leading-sm uppercase bg-green-600 text-white rounded-full">
                              Checked In
                            </div>
                            <div v-else
                              class="mr-4 md:mr-0 mt-0 md:mt-2 px-3 py-1 inline-flex text-xs items-center font-bold leading-sm uppercase bg-red-500 text-white rounded-full">
                              Not checked in
                            </div>

                            <!-- Profiles on the right (mobile) / bottom (desktop) -->
                            <div class="flex items-center md:justify-end mt-0 md:mt-2">
                              <div v-for="(profile, index) in timeslot.meet.profiles" :key="profile.id"
                                class="-ml-[20px] first:ml-0" :style="{ zIndex: profile.length - index }">
                                <img
                                  class="rounded-full border-2 object-cover h-10 w-10 md:h-16 md:w-16 border-gray-200"
                                  :src="profile.profilePic" alt="Profile" @click="toggleAttendeeModal(timeslot)" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="timeslot.state === 'fullyBooked'"
                        class="flex flex-col items-center justify-center text-gray-200 mb-4 h-full text-center font-black text-xl sm:text-3xl">
                        FULLY BOOKED TIME SLOT
                      </div>
                      <div v-else-if="timeslot.state === 'blocked'"
                        class="flex flex-column items-center justify-center text-gray-200 mb-4 h-full text-center font-black text-xl sm:text-3xl">
                        BLOCKED
                      </div>
                      <div v-else-if="timeslot.state === 'available'"
                        class="flex flex-col items-center justify-center text-gray-200 mb-4 h-full text-center font-black text-xl sm:text-3xl">
                        AVAILABLE TIME SLOT
                      </div>
                    </div>

                    <div v-if="timeslot.keynote" v-html="timeslot.keynote" class="text-red-600 italic text-center">
                    </div>

                    <div v-if="schedulerEnabled" class="bottom-0 w-full flex justify-between items-center">
                      <div v-if="timeslot.meet && (timeslot.state === 'accepted' || timeslot.state === 'pending')"
                        class="flex items-center space-x-2 ">
                        <button type="button"
                          class="button !ml-0 border border-gray-300 rounded-md bg-white hover:bg-white text-gray-500 hover:text-gray-900 px-4 py-2"
                          title="Notes" @click="toggleNoteModal(timeslot)">
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z" />
                            <path d="M14 3v5h5M16 13H8M16 17H8M10 9H8" />
                          </svg>
                        </button>
                        <button v-if="showAddColleagueButton(timeslot.meet)" type="button"
                          class="button border border-gray-300 rounded-md bg-white hover:bg-white text-gray-500 hover:text-gray-900 px-4 py-2"
                          title="Add Colleague" @click="toggleColleagueModal(timeslot)">
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="8.5" cy="7" r="4"></circle>
                            <line x1="20" y1="8" x2="20" y2="14"></line>
                            <line x1="23" y1="11" x2="17" y2="11"></line>
                          </svg>
                        </button>
                      </div>
                      

                      <div v-else>
                        <div
                          v-if="isTechTalk(timeslot)"
                          class="relative group font-normal text-gray-400 text-sm w-full overflow-visible"
                          @click="showTechtalkDetails(timeslot)"
                        >
                          <div class="w-full" >
                            <div class="flex items-center w-full transition-colors">
                              <div class="ml-3 min-w-0 flex-1 space-y-[-5px] w-40 md:w-64">
                                <div class="text-[11px] text-gray-400 font-bold truncate">
                                  TECH TALKS
                                </div>
                                <div class="w-full truncate">
                                  {{ getTechTalk(timeslot).timeStart }} -
                                  {{ getTechTalk(timeslot).title }}
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Hover details -->
                          <div
                            class="hidden lg:group-hover:block absolute z-50 left-0 bottom-full mb-3 w-[420px] rounded-2xl bg-white border border-gray-200 shadow-2xl overflow-hidden"
                          >
                            <!-- Header -->
                            <div class="px-5 pt-5 pb-4">
                              <div class="flex items-center justify-between mb-2">
                                <span class="text-[10px] font-bold uppercase">
                                  Tech Talk
                                </span>

                                <span class="text-xs text-gray-400">
                                  {{ getTechTalk(timeslot).timeStart }} -
                                  {{ getTechTalk(timeslot).timeEnd }}
                                </span>
                              </div>

                              <div class="text-base font-semibold leading-snug text-green-600">
                                {{ getTechTalk(timeslot).title }}
                              </div>
                            </div>

                            <!-- Speakers -->
                            <div
                              v-if="getTechTalk(timeslot).speakers?.length"
                              class="border-t border-gray-100 px-5 py-4"
                            >
                              <div class="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">
                                {{ getTechTalk(timeslot).speakers?.length > 1 ? "Speakers" :"Speaker" }}
                              </div>

                              <div class="space-y-3">
                                <div
                                  v-for="speaker in getTechTalk(timeslot).speakers"
                                  :key="speaker.name"
                                  class="flex items-center"
                                >
                                  <!-- Profile -->
                                  <div
                                    class="flex-shrink-0 w-8 h-8 rounded-full bg-gray-100 overflow-hidden flex items-center justify-center text-gray-500 font-semibold"
                                  >
                                    <img
                                      v-if="speaker.profilePic"
                                      :src="speaker.profilePic"
                                      :alt="speaker.name"
                                      class="w-full h-full object-cover"
                                    />

                                    <span v-else class="text-sm">
                                      {{ speaker.name.charAt(0) }}
                                    </span>
                                  </div>

                                  <!-- Details -->
                                  <div class="ml-3 min-w-0">
                                    <div class="text-sm font-semibold text-gray-900 truncate">
                                      {{ speaker.name }}
                                    </div>

                                    <div class="text-xs text-gray-500 truncate">
                                      {{ speaker.company }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>





                      <!-- Action Buttons (Right) -->
                      <div class="flex justify-end space-x-2 w-full">
                        <div v-if="timeslot.state === 'pending' && timeslot.meet.isMeFrom"
                          class="flex flex-row flex-wrap">
                          <button type="button"
                            class="button bg-white hover:bg-white border border-gray-300 hover:border-gray-400 text-gray-400 hover:text-gray-700 !mt-0"
                            @click="confirmDeleteRequest(timeslot, 'cancel')">Cancel Request</button>
                          <button type="button" class="button !mb-0" @click="confirmSendReminder(timeslot)">
                            <!-- Icon (shown on small screens) -->
                            <svg fill="#ffffff" width="20px" height="20px" viewBox="0 0 32 32"
                              class="fa-solid fa-bell sm:hidden">
                              <path
                                d="M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z" />
                              <path
                                d="M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z" />
                            </svg>

                            <!-- Text (shown on medium and up) -->
                            <span class="hidden sm:inline">Send Reminder</span>
                          </button>
                        </div>
                        <div v-else-if="timeslot.state === 'pending' && !timeslot.meet.isMeFrom">
                          <button type="button"
                            class="button bg-white hover:bg-white border border-gray-300 hover:border-gray-400 text-gray-400 hover:text-gray-700"
                            @click="confirmDeleteRequest(timeslot, 'decline')">Decline Request</button>
                          <button type="button" class="button" @click="confirmAcceptRequest(timeslot)">Accept
                            Request</button>
                        </div>
                        <div v-else-if="timeslot.state === 'blocked'">
                          <button type="button" class="button" @click="toggleTimeslotBlock(timeslot.id, 'unblock')">
                            <svg class="md:hidden" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                              viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round">
                              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                              <path d="M7 11V7a5 5 0 0 1 9.9-1"></path>
                            </svg>
                            <span class="hidden md:inline">Unblock Time slot</span>
                          </button>
                        </div>
                        <div v-else-if="timeslot.state === 'accepted'">
                          <button v-if="showCanNotAttendButton(timeslot)" type="button" class="button"
                            @click="toggleCanNotAttend(timeslot)">Can't Attend</button>
                          <button v-if="showCancelMeetingButton(timeslot.meet)" type="button" class="button"
                            @click="confirmDeleteMeeting(timeslot)">Cancel Meeting</button>
                        </div>
                        <div v-else-if="timeslot.state === 'available'">
                          <button type="button"
                            class="button bg-white hover:bg-white border border-gray-300 hover:border-gray-400 text-gray-400 hover:text-gray-700"
                            @click="toggleTimeslotBlock(timeslot.id, 'block')">
                            <svg class="md:hidden" width="18" height="18" viewBox="0 0 24 24" fill="none"
                              stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                            </svg> <!-- Text for larger screens -->
                            <span class="hidden md:inline">Block Time slot</span>
                          </button>
                          <button type="button" class="button" @click="createMeetingRequest(timeslot)">
                            <svg class="md:hidden" width="16" height="18" viewBox="0 0 24 24" fill="none"
                              stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                              <circle cx="9" cy="7" r="4"></circle>
                              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                            <span class="hidden md:inline">Request Meeting</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div v-else>

          <!-- for normal displays //-->
          <div class="mt-6 flex flex-col hidden lg:block">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
              <div v-if="meetsCancelled.length > 0"
                class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
                <table class="min-w-full">
                  <thead>
                    <tr>
                      <th class="table-cell-header pl-2">Meeting with</th>
                      <th class="table-cell-header">Company name</th>
                      <th class="table-cell-header">Mobile</th>
                      <th class="table-cell-header">Scheduled for</th>
                      <th class="table-cell-header">Cancelled on</th>
                      <th class="table-cell-header pl-2">Attendees</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in meetsCancelled" :key="index"
                      class="bg-white hover:bg-gray-100 transition duration-150 ease-in-out">
                      <td class="table-cell text-gray-900 pr-0 pl-2"><a
                          :href="`/attendeeDetails/${item.contact.companyId}`" target="new" rel="noopener"
                          class="text-red-600 hover:text-red-400">{{ item.contact.name }}</a></td>
                      <td class="table-cell text-gray-900"><a :href="`/attendeeDetails/${item.contact.companyId}`"
                          target="new" rel="noopener" class="text-red-600 hover:text-red-400">{{
                            item.contact.companyName }}</a></td>
                      <td class="table-cell text-gray-900"><a :href="`tel:${item.contact.tel}`"
                          class="text-red-600 hover:text-red-400">{{ item.contact.tel }}</a></td>
                      <td class="table-cell text-gray-500">{{ getMeetingDayDetails(item.timeslotId) }}</td>
                      <td class="table-cell text-gray-900">{{ formatDate(item.dtCancelled) }}</td>
                      <td>
                        <div class="flex items-center p-1">
                          <div v-for="(profile, index) in item.profiles" :key="profile.id" class="-ml-[10px] first:ml-0"
                            :style="{ zIndex: profile.length - index }">
                            <img class="rounded-full border-2 object-cover h-8 w-8 border-gray-200"
                              :src="profile.profilePic" alt="Profile" />
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else>
                Any confirmed meetings that have been cancelled will be visible here.<br />
                You currently do not have any cancelled meetings.
              </div>
            </div>
          </div>

          <!-- for mobile displays //-->
          <div class="mt-6 flex flex-col block lg:hidden">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
              <div v-if="meetsCancelled.length > 0"
                class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
                <div v-for="(item, index) in meetsCancelled" :key="index"
                  class="bg-white transition duration-150 ease-in-out p-4 mt-2 mb-3 rounded-sm">
                  <div class="flex justify-between items-center">

                    <!-- Left: Contact link -->
                    <a :href="`/attendeeDetails/${item.contact.companyId}`" target="new" rel="noopener"
                      class="text-red-600 hover:text-red-400">
                      <div class="font-bold text-base">{{ item.contact.name }}</div>
                      <div>{{ item.contact.companyName }}</div>
                    </a>

                    <!-- Right: Profiles -->
                    <div class="flex items-center">
                      <div v-for="(profile, index) in item.profiles" :key="profile.id" class="-ml-[15px] first:ml-0"
                        :style="{ zIndex: item.profiles.length - index }">
                        <img class="rounded-full border-2 object-cover h-10 w-10 border-gray-200"
                          :src="profile.profilePic" alt="Profile" />
                      </div>
                    </div>
                  </div>

                  <div class="grid grid-cols-[90px_1fr] gap-x-2">
                    <span class="font-semibold ">Tel:</span>
                    <a :href="`tel:${item.contact.tel}`" class="text-red-600 hover:text-red-400">{{ item.contact.tel
                      }}</a>
                    <span class="font-semibold">Meeting:</span>
                    <span class="text-gray-400">{{ getMeetingDayDetails(item.timeslotId, true) }}</span>
                    <span class="font-semibold ">Cancelled:</span>
                    <span class="text-gray-400">{{ formatDate(item.dtCancelled) }}</span>
                  </div>
                </div>
              </div>
              <div v-else>
                Any confirmed meetings that have been cancelled will be visible here.<br />
                You currently do not have any cancelled meetings.
              </div>
            </div>
          </div>

        </div>

        <modal v-show="showConfirmDeleteRequest" @submit="deleteRequest()" @cancel="showConfirmDeleteRequest = false"
          header="Confirm cancellation of meeting request" affirmativeButtonLabel='Yes, confirm' cancelButtonLabel="No">
          <template v-slot:body>
            <div>Are you sure you want to cancel the meeting request ({{ meetingDetails.timeslot.timeStart }} - {{
              meetingDetails.timeslot.timeEnd }}) with {{ meetingDetails.timeslot.meet.contact.name }} from
              {{ meetingDetails.timeslot.meet.contact.companyName }}?</div>
          </template>
        </modal>

        <modal v-show="showConfirmDeclineRequest" @submit="deleteRequest()" @cancel="showConfirmDeclineRequest = false"
          header="Confirm declining of meeting request" affirmativeButtonLabel='Yes, decline' cancelButtonLabel="No">
          <template v-slot:body>
            <div>Are you sure you want to decline the meeting request ({{ meetingDetails.timeslot.timeStart }} - {{
              meetingDetails.timeslot.timeEnd }}) by {{ meetingDetails.timeslot.meet.contact.name }} from
              {{ meetingDetails.timeslot.meet.contact.companyName }}?</div>
          </template>
        </modal>

        <modal v-show="showConfirmAcceptRequest" @submit="acceptRequest()" @cancel="showConfirmAcceptRequest = false"
          header="Confirm meeting request" affirmativeButtonLabel='Yes, confirm' cancelButtonLabel="No">
          <template v-slot:body>
            <div>Are you sure you want to accept the meeting request ({{ meetingDetails.timeslot.timeStart }} - {{
              meetingDetails.timeslot.timeEnd }}) from {{ meetingDetails.timeslot.meet.contact.name }} from
              {{ meetingDetails.timeslot.meet.contact.companyName }}?</div>
          </template>
        </modal>

        <modal v-show="showConfirmDeleteMeeting" @submit="deleteMeeting()" @cancel="showConfirmDeleteMeeting = false"
          header="Confirm cancellation of meeting" affirmativeButtonLabel='Yes, confirm' cancelButtonLabel="No">
          <template v-slot:body>
            <div>Are you sure you want to cancel the meeting ({{ meetingDetails.timeslot.timeStart }} - {{
              meetingDetails.timeslot.timeEnd }}) with {{ meetingDetails.timeslot.meet.contact.name }} from
              {{ meetingDetails.timeslot.meet.contact.companyName }}?</div>
          </template>
        </modal>

        <modal v-show="showSendReminder" @submit="sendReminder()" @cancel="showSendReminder = false"
          header="Confirm sending reminder" affirmativeButtonLabel='Yes, confirm' cancelButtonLabel="No">
          <template v-slot:body>
            <div>Are you sure you want to send the reminder of this meeting ({{ meetingDetails.timeslot.timeStart }} -
              {{ meetingDetails.timeslot.timeEnd }}) to {{ meetingDetails.timeslot.meet.contact.name }} from
              {{ meetingDetails.timeslot.meet.contact.companyName }}?</div>
          </template>
        </modal>

        <modal v-show="showMeetingNotesModal" @submit="handleAddNote()" @cancel="showMeetingNotesModal = false"
          header="Meeting Notes" affirmativeButtonLabel='Add' cancelButtonLabel="Close" :disableSubmit="!isNoteValid">
          <template v-slot:body>
            <div class="flex flex-col max-h-[400px] mt-2">
              <div ref="notesContainer" class="overflow-y-auto pr-1 flex-1">
                <div v-for="note in notes" :key="note.id" class="bg-gray-100 p-3 mb-2 rounded">
                  <div class="w-full flex justify-between items-start">
                    <div class="flex-1">
                      <div class="text-base text-justify overflow-hidden break-all whitespace-break-spaces">{{
                        note.message }}</div>
                    </div>

                    <button v-if="note.createdBy === user.id" class="px-2" @click="handleDeleteNote(note.id)">
                      <div class="group w-[18px] h-[18px] cursor-pointer">
                        <svg width="18px" height="18px" viewBox="0 0 24 24" fill="none" class="w-full h-full">
                          <path
                            d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z"
                            stroke="#999999" stroke-width="1.5" class="group-hover:stroke-red-500 transition-colors" />
                          <path d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5" stroke="#999999" stroke-width="1.5"
                            stroke-linecap="round" class="group-hover:stroke-red-500 transition-colors" />
                        </svg>
                      </div>
                    </button>
                  </div>
                  <div class="w-full flex justify-between items-start mt-1">
                    <div class="flex-1" v-if="note.private">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M7 10.0288C7.47142 10 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10 17 10.0288M7 10.0288C6.41168 10.0647 5.99429 10.1455 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C18.0057 10.1455 17.5883 10.0647 17 10.0288M7 10.0288V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10.0288"
                          stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>
                    <div class="text-xs text-gray-400 ml-auto">
                      {{ note.name }} | {{ formatDate(note.dateCreated) }}
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="loadingNotes" class="space-y-3 py-5 px-1">
                <div class="animate-pulse space-y-2">
                  <div class="h-4 bg-gray-300 rounded w-full"></div>
                  <div class="h-4 bg-gray-300 rounded w-full"></div>
                  <div class="h-4 bg-gray-300 rounded w-3/4"></div>
                </div>
                <div class="animate-pulse space-y-2">
                  <div class="h-4 bg-gray-300 rounded w-full"></div>
                  <div class="h-4 bg-gray-300 rounded w-full"></div>
                  <div class="h-4 bg-gray-300 rounded w-3/4"></div>
                </div>
              </div>
              <div class="sticky bottom-0 bg-white pt-3">
                <div class="flex justify-between items-center">
                  <span class="text-sm font-medium text-gray-500">Add Meeting Notes</span>
                  <label class="flex items-center cursor-pointer space-x-2">
                    <div class="relative">
                      <input type="checkbox" v-model="isPrivate" class="sr-only peer" />
                      <div
                        class="w-10 h-5 bg-gray-300 peer-checked:bg-teal-600 rounded-full transition-colors duration-300">
                      </div>
                      <div
                        class="absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow-md transition-transform duration-300 peer-checked:translate-x-5">
                      </div>
                    </div>
                    <span class="w-[48px] text-xs text-gray-500 text-center">
                      {{ isPrivate ? 'Private' : 'Public' }}
                    </span>
                  </label>
                </div>

                <textarea v-model="newNote" @input="autoResize" rows="3" ref="noteTextarea"
                  class="form-input block w-full resize-none mt-3 overflow-hidden leading-snug min-h-[2.5rem] max-h-[8rem]"></textarea>
              </div>
            </div>

          </template>
        </modal>

        <modal v-show="showCanNotAttendModal" @submit="handleCanNotAttend()" @cancel="showCanNotAttendModal = false;"
          header="Warning" affirmativeButtonLabel='Yes' cancelButtonLabel="Close">
          <template v-slot:body>
            <p class="h2">This will remove you from the list of attendees. Are you sure you want to continue?</p>
          </template>
        </modal>

        <modal v-show="showColleagueModal" @cancel="showColleagueModal = false" header="Available Colleagues"
          :hideSubmit="true" cancelButtonLabel="Close">
          <template v-slot:body>
            <div v-if="loadingColleagues">
              <div class="space-y-3 py-5 px-1">
                <div class="animate-pulse space-y-2">
                  <div class="h-4 bg-gray-300 rounded w-full"></div>
                  <div class="h-4 bg-gray-300 rounded w-full"></div>
                  <div class="h-4 bg-gray-300 rounded w-3/4"></div>
                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="availableColleagues.length == 0">
                <p class="text-base text-center mt-4">You have no available colleague for this timeslot.</p>
              </div>

              <div v-else class="mt-4 space-y-2">
                <div v-for="colleague in availableColleagues" :key="colleague.id"
                  class="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-gray-100 p-4 rounded shadow space-y-4 sm:space-y-0">
                  <div class="flex items-center">
                    <img :src="colleague.profilePic" :alt="colleague.name"
                      class="w-16 h-16 rounded-full object-cover border mr-4" />
                    <div class="text-left overflow-hidden break-all whitespace-break-spaces">
                      <div class="text-base font-semibold">
                        {{ colleague.name }}
                      </div>
                      <div class="text-sm text-gray-600">
                        {{ colleague.email }}
                      </div>
                      <div class="text-sm text-gray-600">
                        {{ colleague.function }}
                      </div>
                    </div>

                  </div>

                  <!-- Mobile Button -->
                  <button class="!ml-0 button block sm:hidden w-full text-white text-sm font-semibold mt-4 rounded"
                    :disabled="disableAddColleagueButton" @click="handleAddColleague(colleague.id, colleague.name)">
                    Add Colleague
                  </button>

                  <!-- Desktop Icon Button -->
                  <button class="hidden sm:block bg-gray-200 p-2 rounded hover:bg-gray-300"
                    :disabled="disableAddColleagueButton" @click="handleAddColleague(colleague.id, colleague.name)">
                    <!-- <i class="fa-solid fa-user-plus text-white"></i> -->
                    <svg fill="#999999" width="18px" height="18px" viewBox="0 0 32 32" version="1.1">
                      <path
                        d="M2.016 26.016q0 2.496 1.728 4.224t4.256 1.76h10.016v-2.336q-1.28-0.48-2.368-1.664h-7.648q-0.832 0-1.408-0.576t-0.576-1.408q0.672-2.592 2.944-4.288t5.056-1.728q0.736 0 1.44 0.16 1.184-1.376 2.816-1.856 0.384-1.248 1.248-2.24t2.016-1.504q0.48-1.28 0.48-2.56v-4q0-3.296-2.368-5.632t-5.632-2.368-5.664 2.368-2.336 5.632v4q0 3.168 2.208 5.536-2.4 1.344-4.096 3.552t-2.112 4.928zM10.016 12v-4q0-1.632 1.152-2.816t2.848-1.184 2.816 1.184 1.184 2.816v4q0 1.664-1.184 2.848t-2.816 1.152-2.848-1.152-1.152-2.848zM18.016 24q0 0.832 0.576 1.44t1.408 0.576h2.016v1.984q0 0.832 0.576 1.44t1.408 0.576 1.408-0.576 0.608-1.44v-1.984h1.984q0.832 0 1.408-0.576t0.608-1.44-0.608-1.408-1.408-0.576h-1.984v-2.016q0-0.832-0.608-1.408t-1.408-0.576-1.408 0.576-0.576 1.408v2.016h-2.016q-0.832 0-1.408 0.576t-0.576 1.408z">
                      </path>
                    </svg>
                  </button>

                </div>
              </div>
            </div>
          </template>
        </modal>

        <modal v-show="showAttendeeModal" @cancel="showAttendeeModal = false" header="Meeting Attendees"
          :hideSubmit="true" cancelButtonLabel="Close">
          <template v-slot:body>
            <div class="mt-4 space-y-3">

              <div v-for="attendee in meetingDetails.timeslot.meet.profiles" :key="attendee.id"
                class="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-gray-100 p-4 rounded shadow space-y-4 sm:space-y-0">
                <div class="flex items-center">
                  <img :src="attendee.profilePic" :alt="attendee.name"
                    class="w-16 h-16 rounded-full object-cover border mr-4" />
                  <div class="text-left space-y-1 overflow-hidden break-all break-words">
                    <div class="text-base font-semibold ">{{ attendee.name }}</div>
                    <div class="text-sm text-gray-600">{{ attendee.companyName }}</div>
                    <div v-if="attendee.website" class="text-sm text-gray-600">
                      <div v-if="attendee.website" class="flex items-center text-sm text-gray-600 space-x-1">
                        <a :href="formatWebsiteUrl(attendee.website)" target="_blank" rel="noopener"
                          class="text-red-600">
                          {{ attendee.website }}
                        </a>
                      </div>

                    </div>
                    <div v-if="attendee.tel">
                      <a :href="`tel:${attendee.tel}`" class='text-red-600'>{{ attendee.tel }}</a>
                    </div>
                    <button class="text-sm flex items-center gap-1 cursor-pointer" @click="goToChat(attendee.id)">
                      <svg width="22px" height="22px" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M13.0867 21.3877L13.7321 21.7697L13.0867 21.3877ZM13.6288 20.4718L12.9833 20.0898L13.6288 20.4718ZM10.3712 20.4718L9.72579 20.8539H9.72579L10.3712 20.4718ZM10.9133 21.3877L11.5587 21.0057L10.9133 21.3877ZM1.25 10.5C1.25 10.9142 1.58579 11.25 2 11.25C2.41421 11.25 2.75 10.9142 2.75 10.5H1.25ZM3.07351 15.6264C2.915 15.2437 2.47627 15.062 2.09359 15.2205C1.71091 15.379 1.52918 15.8177 1.68769 16.2004L3.07351 15.6264ZM7.78958 18.9915L7.77666 19.7413L7.78958 18.9915ZM5.08658 18.6194L4.79957 19.3123H4.79957L5.08658 18.6194ZM21.6194 15.9134L22.3123 16.2004V16.2004L21.6194 15.9134ZM16.2104 18.9915L16.1975 18.2416L16.2104 18.9915ZM18.9134 18.6194L19.2004 19.3123H19.2004L18.9134 18.6194ZM19.6125 2.7368L19.2206 3.37628L19.6125 2.7368ZM21.2632 4.38751L21.9027 3.99563V3.99563L21.2632 4.38751ZM4.38751 2.7368L3.99563 2.09732V2.09732L4.38751 2.7368ZM2.7368 4.38751L2.09732 3.99563H2.09732L2.7368 4.38751ZM9.40279 19.2098L9.77986 18.5615L9.77986 18.5615L9.40279 19.2098ZM13.7321 21.7697L14.2742 20.8539L12.9833 20.0898L12.4412 21.0057L13.7321 21.7697ZM9.72579 20.8539L10.2679 21.7697L11.5587 21.0057L11.0166 20.0898L9.72579 20.8539ZM12.4412 21.0057C12.2485 21.3313 11.7515 21.3313 11.5587 21.0057L10.2679 21.7697C11.0415 23.0767 12.9585 23.0767 13.7321 21.7697L12.4412 21.0057ZM10.5 2.75H13.5V1.25H10.5V2.75ZM21.25 10.5V11.5H22.75V10.5H21.25ZM7.8025 18.2416C6.54706 18.2199 5.88923 18.1401 5.37359 17.9265L4.79957 19.3123C5.60454 19.6457 6.52138 19.7197 7.77666 19.7413L7.8025 18.2416ZM1.68769 16.2004C2.27128 17.6093 3.39066 18.7287 4.79957 19.3123L5.3736 17.9265C4.33223 17.4951 3.50486 16.6678 3.07351 15.6264L1.68769 16.2004ZM21.25 11.5C21.25 12.6751 21.2496 13.5189 21.2042 14.1847C21.1592 14.8438 21.0726 15.2736 20.9265 15.6264L22.3123 16.2004C22.5468 15.6344 22.6505 15.0223 22.7007 14.2868C22.7504 13.5581 22.75 12.6546 22.75 11.5H21.25ZM16.2233 19.7413C17.4786 19.7197 18.3955 19.6457 19.2004 19.3123L18.6264 17.9265C18.1108 18.1401 17.4529 18.2199 16.1975 18.2416L16.2233 19.7413ZM20.9265 15.6264C20.4951 16.6678 19.6678 17.4951 18.6264 17.9265L19.2004 19.3123C20.6093 18.7287 21.7287 17.6093 22.3123 16.2004L20.9265 15.6264ZM13.5 2.75C15.1512 2.75 16.337 2.75079 17.2619 2.83873C18.1757 2.92561 18.7571 3.09223 19.2206 3.37628L20.0044 2.09732C19.2655 1.64457 18.4274 1.44279 17.4039 1.34547C16.3915 1.24921 15.1222 1.25 13.5 1.25V2.75ZM22.75 10.5C22.75 8.87781 22.7508 7.6085 22.6545 6.59611C22.5572 5.57256 22.3554 4.73445 21.9027 3.99563L20.6237 4.77938C20.9078 5.24291 21.0744 5.82434 21.1613 6.73809C21.2492 7.663 21.25 8.84876 21.25 10.5H22.75ZM19.2206 3.37628C19.7925 3.72672 20.2733 4.20752 20.6237 4.77938L21.9027 3.99563C21.4286 3.22194 20.7781 2.57144 20.0044 2.09732L19.2206 3.37628ZM10.5 1.25C8.87781 1.25 7.6085 1.24921 6.59611 1.34547C5.57256 1.44279 4.73445 1.64457 3.99563 2.09732L4.77938 3.37628C5.24291 3.09223 5.82434 2.92561 6.73809 2.83873C7.663 2.75079 8.84876 2.75 10.5 2.75V1.25ZM2.75 10.5C2.75 8.84876 2.75079 7.663 2.83873 6.73809C2.92561 5.82434 3.09223 5.24291 3.37628 4.77938L2.09732 3.99563C1.64457 4.73445 1.44279 5.57256 1.34547 6.59611C1.24921 7.6085 1.25 8.87781 1.25 10.5H2.75ZM3.99563 2.09732C3.22194 2.57144 2.57144 3.22194 2.09732 3.99563L3.37628 4.77938C3.72672 4.20752 4.20752 3.72672 4.77938 3.37628L3.99563 2.09732ZM11.0166 20.0898C10.8136 19.7468 10.6354 19.4441 10.4621 19.2063C10.2795 18.9559 10.0702 18.7304 9.77986 18.5615L9.02572 19.8582C9.07313 19.8857 9.13772 19.936 9.24985 20.0898C9.37122 20.2564 9.50835 20.4865 9.72579 20.8539L11.0166 20.0898ZM7.77666 19.7413C8.21575 19.7489 8.49387 19.7545 8.70588 19.7779C8.90399 19.7999 8.98078 19.832 9.02572 19.8582L9.77986 18.5615C9.4871 18.3912 9.18246 18.3215 8.87097 18.287C8.57339 18.2541 8.21375 18.2487 7.8025 18.2416L7.77666 19.7413ZM14.2742 20.8539C14.4916 20.4865 14.6287 20.2564 14.7501 20.0898C14.8622 19.936 14.9268 19.8857 14.9742 19.8582L14.2201 18.5615C13.9298 18.7304 13.7204 18.9559 13.5379 19.2063C13.3646 19.4441 13.1864 19.7468 12.9833 20.0898L14.2742 20.8539ZM16.1975 18.2416C15.7862 18.2487 15.4266 18.2541 15.129 18.287C14.8175 18.3215 14.5129 18.3912 14.2201 18.5615L14.9742 19.8582C15.0192 19.832 15.096 19.7999 15.2941 19.7779C15.5061 19.7545 15.7842 19.7489 16.2233 19.7413L16.1975 18.2416Z"
                          fill="#1C274C" />
                        <path d="M8 11H8.009M11.991 11H12M15.991 11H16" stroke="#1C274C" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>Chat
                    </button>
                  </div>
                </div>

                <!-- Mobile Button -->
                <button v-if="displayRemoveButton(attendee.id, attendee.companyId)"
                  class="block sm:hidden w-full bg-red-600 text-white text-sm font-semibold py-2 mt-4 rounded"
                  @click="handleRemoveColleague(attendee.id)">
                  Remove Colleague
                </button>
                <!-- Desktop Icon Button -->
                <button v-if="displayRemoveButton(attendee.id, attendee.companyId)"
                  class="hidden sm:block bg-gray-200 p-2 rounded hover:bg-gray-300"
                  @click="handleRemoveColleague(attendee.id)" title="Remove Attendee">
                  <svg width="18px" height="18px" version="1.1" id="Layer_1" viewBox="0 0 32 32" xml:space="preserve">
                    <circle style="fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;" cx="14" cy="11"
                      r="6" />
                    <path style="fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;" d="M5,26c0-4.971,4.029-9,9-9
                    c1.864,0,3.596,0.567,5.032,1.537" />
                    <circle style="fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;" cx="24" cy="24"
                      r="7" />
                    <line style="fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;" x1="21" y1="27" x2="27"
                      y2="21" />
                    <line style="fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;" x1="21" y1="21" x2="27"
                      y2="27" />
                  </svg>
                </button>
              </div>
            </div>
          </template>
        </modal>

        <modal v-show="showTechTalkDetailsModal" @cancel="showTechTalkDetailsModal = false" header="TechTalk Details"
          :hideSubmit="true" cancelButtonLabel="Close">
          <template v-slot:body>
            <div v-if="techtalkDetails" class="mt-4 space-y-3">
              <!-- Header -->
              <div class="">
                <div class="text-lg font-semibold text-gray-800 leading-snug">
                  {{ techtalkDetails.title }}
                </div>
                <div class="text-xs text-gray-400 mt-4">
                  {{ getTechTalk(activeTimeslot).timeStart }} -
                  {{ getTechTalk(activeTimeslot).timeEnd }}
                </div>
              </div>

              <!-- Speakers -->
              <div
                v-if="techtalkDetails.speakers?.length"
                class="border-t border-gray-100 pt-4"
              >
                <div class="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">
                  Speakers
                </div>

                <div class="space-y-3">
                  <div
                    v-for="speaker in techtalkDetails.speakers"
                    :key="speaker.name"
                    class="flex items-center"
                  >
                    <!-- Profile -->
                    <div
                      class="flex-shrink-0 w-10 h-10 rounded-full bg-gray-100 overflow-hidden flex items-center justify-center text-gray-500 font-semibold"
                    >
                      <img
                        v-if="speaker.profilePic"
                        :src="speaker.profilePic"
                        :alt="speaker.name"
                        class="w-full h-full object-cover"
                      />

                      <span v-else class="text-sm">
                        {{ speaker.name.charAt(0) }}
                      </span>
                    </div>

                    <!-- Details -->
                    <div class="ml-3 min-w-0">
                      <div class="text-sm font-semibold text-gray-900 truncate">
                        {{ speaker.name }}
                      </div>

                      <div class="text-xs text-gray-500 truncate">
                        {{ speaker.company }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </modal>
      </div>

    </template>
  </base-layout>
</template>

<script>
import _ from "lodash";
import { mapState, mapActions } from "vuex";
import Modal from "@/components/modal"

import BaseLayout from "../components/BaseLayout.vue";
import eventBus from '../utils/eventBus'
import { all } from "bluebird";

export default {
  name: "Register",
  components: {
    BaseLayout,
    Modal,
  },
  data() {
    return {
      shouldSkipPic: false,
      isLoaded: false,
      days: null,
      numTables: null,
      numTablesMax: null,
      timeslotsByDay: null,
      currentTab: "0", // 0 (day 1), 1 (day 2), 2 (cancelled meetings)
      timezone: "(CEST)",
      meets: null,
      meetsCancelled: null,
      contacts: null, // contacts for each meeting
      allSettings: null,
      schedulerEnabled: false,
      showConfirmDeleteRequest: false,
      showConfirmDeclineRequest: false,
      showConfirmAcceptRequest: false,
      showConfirmDeleteMeeting: false,
      showSendReminder: false,
      captainsLunchDayNumber: null,
      activeMenuId: null,
      showMeetingNotesModal: false,
      showColleagueModal: false,
      showAttendeeModal: false,
      newNote: null,
      notes: [],
      availableColleagues: [],
      search: '',
      showCanNotAttendModal: false,
      isPrivate: false,
      loadingNotes: false,
      disableAddColleagueButton: false,
      loadingColleagues: false,
      attendeeCount: 0,
      statusFilter: 'All',
      captainsDinnerRegistrationStatus: null,
      timeslotMapAll: null,
      companyMeetings: null,
      meetingDetails: {
        timeslot: {
          timeStart: null,
          timeEnd: null,
          meet: {
            contact: {
              name: null,
              email: null,
              tell: null,
              companyName: null,
            },
          }
        }
      },
      showTechTalkDetailsModal: false,
      activeTimeslot: null,
      techtalkDetails: null,
      timeslotNotification: "TechTalks will be held at this time.<br>You may want to keep this time open in your schedule",
      techtalks: [],
      speakers: [],
      currentUser: JSON.parse(localStorage.getItem("user") || "null"),
      techTalks: [
        {
          timeStart: "10:00",
          timeEnd: "10:10",
          title: "Welcome to ITAD Association Tech Talks",
          speakers: [
            {
              name: "Billy Marion",
              company: "ITAD Association",
              profilePic: "https://www.europeanbrokermeeting.com/images/speakers/billymarion.png"
            }
          ]
        },
        {
          timeStart: "10:10",
          timeEnd: "10:55",
          title: "Industry Leaders Panel",
          speakers: [
            {
              name: "John Spagnuolo",
              company: "IQ Reseller",
              profilePic: "https://www.europeanbrokermeeting.com/images/speakers/johnspagnuolo.jfif"
            },
            {
              name: "Todd Bone",
              company: "PyxTech & iFixit",
              profilePic: null
            },
            {
              name: "Andreas Fibiger",
              company: "Inside Systems",
              profilePic: "https://www.europeanbrokermeeting.com/images/speakers/andreasfibiger.jfif"
            }
          ]
        },
        {
          timeStart: "11:00",
          timeEnd: "11:30",
          title: "Automation in ITAD with REMI",
          speakers: [
            {
              name: "Anirban Ghose",
              company: "RenewIT",
              profilePic: null
            },
            {
              name: "Lucas Way",
              company: "RenewIT",
              profilePic: null
            }
          ]
        },
        {
          timeStart: "11:35",
          timeEnd: "12:05",
          title: "How AI Will Mess Up Our Intransparent Market – and Other Crazy Ideas for the Future",
          speakers: [
            {
              name: "Michael Schmelcher",
              company: "Re:Rebellion",
              profilePic: "https://www.europeanbrokermeeting.com/images/speakers/michaelschmelcher.jfif"
            }
          ]
        },
        {
          timeStart: "14:00",
          timeEnd: "14:05",
          title: "Welcome Back to ITAD Association Tech Talks",
          speakers: [
            {
              name: "Billy Marion",
              company: "ITAD Association",
              profilePic: "https://www.europeanbrokermeeting.com/images/speakers/billymarion.png"
            }
          ]
        },
        {
          timeStart: "14:05",
          timeEnd: "14:35",
          title: "Topic TBD",
          speakers: [
            {
              name: "Victoria D'Arcy",
              company: "All Things Circular",
              profilePic: "https://www.europeanbrokermeeting.com/images/speakers/victoriadarcy.jfif"
            }
          ]
        },
        {
          timeStart: "14:40",
          timeEnd: "15:10",
          title: "The Convergence Point: What's Actually Next for ITAD",
          speakers: [
            {
              name: "Yves Gheeraert",
              company: "Blancco",
              profilePic: "https://www.europeanbrokermeeting.com/images/speakers/yvesgheeraert.jfif"
            }
          ]
        },
        {
          timeStart: "15:15",
          timeEnd: "15:45",
          title: "XDE Software as a Final Stage in ITAD",
          speakers: [
            {
              name: "Tomasz Laskowski",
              company: "Netland",
              profilePic: null
            }
          ]
        },
        {
          timeStart: "16:35",
          timeEnd: "16:45",
          title: "Tech Talks Closing",
          speakers: [
            {
              name: "Billy Marion",
              company: "ITAD Association",
              profilePic: "https://www.europeanbrokermeeting.com/images/speakers/billymarion.png"
            },
            {
              name: "Joe Marion",
              company: "Moderator",
              profilePic: "https://www.europeanbrokermeeting.com/images/speakers/joemarion.png"
            }
          ]
        }
      ]

    };
  },
  computed: {
    ...mapState(["user", 'keynotes']),
    isTechTalk() {
      return (timeslot) => {
        if (timeslot.day !== 1) return false;

        return this.techTalks.some(
          techTalk =>
            timeslot.timeStart < techTalk.timeEnd &&
            timeslot.timeEnd > techTalk.timeStart
        );
      };
    },

    getTechTalk() {
      return (timeslot) => {
        if (timeslot.day !== 1) return null;

        const toMinutes = (time) => {
          const [hours, minutes] = time.split(":").map(Number);
          return hours * 60 + minutes;
        };

        const slotStart = toMinutes(timeslot.timeStart);
        const slotEnd = toMinutes(timeslot.timeEnd);

        return this.techTalks.find(techTalk => {
          const talkStart = toMinutes(techTalk.timeStart);
          const talkEnd = toMinutes(techTalk.timeEnd);

          return slotStart < talkEnd && slotEnd > talkStart;
        }) || null;
      };
    },

    currentTimeslots() {
      // if(this.statusFilter === "AllMeetings") {
      //   return this.companyMeetings;
      // }

      if (this.statusFilter === "AllMeetings") {
        return this.companyMeetings.filter(
          meeting => meeting.day === +this.currentTab + 1
        );
      }

      const timeslots = this.timeslotsByDay[+this.currentTab + 1] || []

      if (this.statusFilter === 'Pending')
        return timeslots.filter(ts => ts.state === 'pending')
      if (this.statusFilter === 'Available')
        return timeslots.filter(ts => ts.state === 'available')
      else if (this.statusFilter === 'Confirmed')
        return timeslots.filter(ts => ts.state === 'accepted')
      else if (this.statusFilter === 'Blocked')
        return timeslots.filter(ts => ts.state === 'blocked')
      else
        return timeslots
    },
    isNoteValid() {
      return this.newNote?.length > 0
    }
  },
  watch: {
    user: {
      handler(newVal) {
        if (newVal) {
          this.fetchCaptainsLunchSlotsTaken()
        }
      },
      deep: true,
      immediate: false
    },
  },
  async created() {
    try {
      this.allSettings = await this.$http.get("/api/misc/allSettings").then(res => res.data.payload)
      this.schedulerEnabled = Boolean(Number(this.allSettings.schedulerEnabled))
      // if (this.user.companyId==7 || this.user.companyId==244) {this.schedulerEnabled = true} // added temporarily to enable scheduler buttons for testing, only for the test user with the company IDs 7 (TBS) and 244 (Infotechture)
      // this.homepageText = await this.$http.get("/api/misc/allSettings").then(res => res.data.payload.mainpage_text)
    } catch (err) {
      console.log("err", err)
    }

    if (this.currentUser) {
      await this.reload()
      this.isLoaded = true
      this.setAttendeeCount()
      this.getTechTalks()
      this.fetchCaptainsLunchSlotsTaken()
    }
  },
  async mounted() {
    this.shouldSkipPic = !!this.user
    const { a: action = '', id: auth = null, cd: selectedDay = 0 } = this.$route.query
    this.currentTab = selectedDay // set the current day to whatever is selected in the querystring. If nothing is entered, use 0 (Thursday)

    if (auth) {
      if (this.currentUser) {
        try {
          await new Promise(resolve => setTimeout(resolve, 2000));
          const resp = await this.$http.get(`/api/scheduler/meetings/${auth}/action/meetingIdByAuth`)
          const selectedMeetingId = resp.data.meetingId
          // const selectedTimeslot = this.currentTimeslots.find(timeslot => timeslot.meet && timeslot.meet.id === selectedMeetingId)

          switch (action) {
            case '1':
              this.meetingDetails.delAction = 'accept'
              this.meetingDetails.timeslot.meet.id = selectedMeetingId
              this.acceptRequest()
              break
            case '2':
              this.meetingDetails.delAction = 'decline'
              this.meetingDetails.timeslot.meet.id = selectedMeetingId
              this.deleteRequest()
              break
          }

          // this.$router.push(`/scheduler?cd=${selectedDay}`)
        } catch (err) {
          console.log("err", err)
        }

        await this.reload() // make sure we have all the timeslots loaded
        this.currentTab = String(parseInt(this.currentTab) + 1)
        this.currentTab = String(parseInt(this.currentTab) - 1)
      }
    }
  },
  methods: {
    ...mapActions(["addNote", "getNotes", "deleteNote", "getAvailableColleague", "addColleague", "canAttendtheMeeting", "removeColleague", "getAttendeeCount"]),
    
    async fetchCompanyMeetings() {
      await this.$http.get("/api/scheduler/company-meetings").then(res => {
        

        const meetings = res.data.allMeetings
        const contacts = res.data.contacts

        this.companyMeetings = _.map(
          _.keyBy(this.timeslotMapAll, 'id'),
          timeslotMapAll => ({
            ...timeslotMapAll,
            contacts: contacts
              .filter(contact => !meetings.some(
                m => m.timeslotId === timeslotMapAll.id &&
                    m.attendeeId === m.contactId &&
                    m.attendeeId === contact.id
              ))  
              .map(contact => {
                const meeting = meetings.find(
                  m => m.timeslotId === timeslotMapAll.id && m.attendeeId === contact.id
                )


                return meeting
                  ? {
                      contactName: contact.name,
                      available: false,
                      showTableLabel: !!meeting.table,
                      table: meeting.table > this.numTables ? 'Hotel Lobby' : `Table ${meeting.table}`,
                      meetingstatus: meeting.status,
                      display: `${meeting.attendeeName} - ${meeting.contactName} (${meeting.companyName})`                  
                    }
                  : {
                      contactName: contact.name,
                      available: true,
                      display: contact.name
                    }
            })
          })
        )

      })
    },  
    async reload() {
      this.$store.dispatch('updateTimeslotRequest', []) // we remove the value of the time slot from the state
      let timeslots
      await this.$http.get("/api/scheduler/timeslots").then(res => {
        timeslots = res.data.timeslots
        this.days = [res.data.metaData.date_start.value, res.data.metaData.date_end.value] // always 2
        this.numTables = res.data.metaData.meeting_tables.value
        this.numTablesMax = res.data.metaData.meeting_tables_max.value // Including lobby seats
        this.timeslotsByDay = _.groupBy(timeslots, 'day')
      })
      const timeslotMap = _.keyBy(timeslots, 'id')
      this.timeslotMapAll = timeslotMap;

      this.fetchCompanyMeetings()

      await this.$http.get("/api/scheduler/meetings").then(res => {
        this.captainsLunchDayNumber = res.data.dayNumber

        const contactMap = _.keyBy(res.data.contacts, 'id')


        _.each([...(res.data.meets || []), ...(res.data.meetsCancelled || []) ], meet => {
          meet.isMeFrom = this.user.id === meet.fromId
          meet.isBlock = this.user.id === meet.fromId && meet.fromId === meet.toId

          if (!meet.isBlock) {
            meet.contact = contactMap[meet.isMeFrom ? meet.toId : meet.fromId]
            meet.contact.mailLink = `mailto:${meet.contact.email}`
            meet.contact.telLink = `tel:${meet.contact.tel}`

            // default to a profile pic outline. White with gray
            meet.contact.profilePic = meet.contact.profilePic || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(meet.contact.name) + '&background=fff&color=aaa'
          }

        })
        this.meets = res.data.meets
        this.meetsCancelled = res.data.meetsCancelled.filter(meet =>
          meet.parentScheduleId == null ||
          (meet.parentScheduleId != null && meet.fromId == this.user.id)
        )

        // ----------------------------------------
        // Profiles for cancelled meetings
        // ----------------------------------------
        _.each(this.meetsCancelled, mc => {
          let mc_attendeeIds = [];
          try {
            mc_attendeeIds = JSON.parse(mc.attendees || '[]');
          } catch (e) {
            mc_attendeeIds = [];
          }

          mc.profiles = _.compact(
            _.map(mc_attendeeIds, id => {
              if (id === this.user.id) return null;
              const contact = contactMap[id];
              if (!contact) return null;

              if (!contact.profilePic || contact.profilePic.length < 5) {
                contact.profilePic = 'https://ui-avatars.com/api/?name=' +
                  encodeURIComponent(contact.name) + '&background=fff&color=aaa';
              }

              return contact;
            })
          );

        })


        _.each(this.meets, meet => {
          const timeslot = timeslotMap[meet.timeslotId];

          if (!timeslot) {
            return; // Skip to avoid crashing
          }


          // Check if the timeslot.meet is already set. 
          // If the meet.id > timeslot.meet.id return, those are 
          // the meeting for the added colleagues
          if (timeslot.meet && meet.id > timeslot.meet.id) return
          timeslot.meet = meet || {};

          let attendeeIds = [];
          try {
            attendeeIds = JSON.parse(timeslot.meet.attendees || '[]');
          } catch (e) {
            attendeeIds = [];
          }

          timeslot.meet.profiles = _.compact(
            _.map(attendeeIds, id => {
              const contact = contactMap[id];
              if (!contact) return null;

              if (!contact.profilePic || contact.profilePic.length < 5) {
                contact.profilePic = 'https://ui-avatars.com/api/?name=' +
                  encodeURIComponent(contact.name) + '&background=fff&color=aaa';
              }

              return contact;
            })
          );
          timeslot.meet = meet;
        });


        _.each(timeslots, timeslot => {
          timeslot.state = 'available'
          timeslot.keynote = this.keynotes[timeslot.id]

          // if ((timeslot.id==4) || (timeslot.id==5)) {
          //   timeslot.keynote = "Presentation by Paolo Tosoratti - refurbished hardware legislation"
          // } else if ((timeslot.id==20) || (timeslot.id==21)) {
          //   timeslot.keynote = "Presentation by Paolo Tosoratti & Davide Polverini - refurbished hardware legislation"
          // } else {
          //   timeslot.keynote = ""
          // }

          // if (this.captainsLunchDayNumber !== null) {
          //   if ((this.captainsLunchDayNumber === 0) && (timeslot.id >= 6 && timeslot.id <= 8)) {
          //     timeslot.keynote = "You are confirmed for the Captain's Lunch in the Rose Meeting Room"
          //   } else if ((this.captainsLunchDayNumber === 1) && (timeslot.id >= 22 && timeslot.id <= 24)) {
          //     timeslot.keynote = "You are confirmed for the Captain's Lunch in the Rose Meeting Room"
          //   }
          // }

          if (timeslot.isFullyBooked) {
            timeslot.state = 'fullyBooked'
          }
          if (timeslot.meet && timeslot.meet.status === 0) {
            if (timeslot.meet.isBlock) {
              timeslot.state = 'blocked'
            } else {
              timeslot.state = 'pending'
            }
          } else if (timeslot.meet && timeslot.meet.status === 1) {
            timeslot.state = 'accepted'
            timeslot.isLobby = timeslot.meet.table > this.numTables
            timeslot.table = timeslot.isLobby ? 'Hotel Lobby' : `Table: ${timeslot.meet.table}`
          }

          switch (timeslot.state) {
            case 'available':
              timeslot.cssContainer = ''
              timeslot.cssHeading = 'bg-gray-400'
              break;
            case 'blocked':
              timeslot.cssContainer = ''
              timeslot.cssHeading = 'bg-yellow-500'
              break;
            case 'pending':
              timeslot.cssContainer = ''
              timeslot.cssHeading = 'bg-red-600'
              break;
            case 'accepted':
              timeslot.cssContainer = ''
              timeslot.cssHeading = 'bg-green-600'
              break;
            case 'fullyBooked':
              timeslot.cssContainer = ''
              timeslot.cssHeading = 'bg-zinc-700'
              break;
          }
        })
      })
    },
    async toggleTimeslotBlock(timeslotId, action) {
      const payload = {
        timeslotId
      }

      const endpoint = action === 'block' ? "/api/scheduler/blockTimeslot" : "/api/scheduler/unblockTimeslot"
      const response = await this.$http.post(endpoint, payload).then(res => res.data.meet)
      await this.reload()

      // TO DO: fix reloading. It works but the schedule slots are not displayed properly
      // Hacky: check on which tab the action is done, switch to another tab and back again. This causes a re-render of the time slots. We need to convert to integer and back to string to make sure all works.
      this.currentTab = String(parseInt(this.currentTab) + 1)
      this.currentTab = String(parseInt(this.currentTab) - 1)
    },
    async deleteRequest() {
      try {
        const url = `/api/scheduler/meetings/${this.meetingDetails.timeslot.meet.id}/action/${this.meetingDetails.delAction}`
        const response = await this.$http.post(url)
        const meet = response.data.meet
        await this.reload()
        this.meetingDetails.delAction == 'cancel' ? this.showConfirmDeleteRequest = false : (this.meetingDetails.delAction == 'decline' ? this.showConfirmDeclineRequest = false : null);
      } catch (error) {
        console.error('Error during request cancellation:', error)
      }
    },
    async acceptRequest() {
      try {
        const url = `/api/scheduler/meetings/${this.meetingDetails.timeslot.meet.id}/action/accept`
        const response = await this.$http.post(url)
        const meet = response.data.meet
        await this.reload()
        this.showConfirmAcceptRequest = false
      } catch (error) {
        console.error('Error during request cancellation:', error)
      }
    },
    async deleteMeeting() {
      try {
        const url = `/api/scheduler/meetings/${this.meetingDetails.timeslot.meet.id}/action/cancel`
        const response = await this.$http.post(url)
        const meet = response.data.meet
        await this.reload()
        this.showConfirmDeleteMeeting = false
      } catch (error) {
        console.error('Error during request cancellation:', error)
      }
    },
    async sendReminder() {
      try {
        const response = await this.$http.post(`/api/scheduler/meetings/${this.meetingDetails.timeslot.meet.id}/action/reminder`)
        const meet = response.data.meet

        if (response.data.status !== 200) {
          eventBus.$emit("createSnackbar", {
            type: "error",
            title: "There was a problem sending your reminder",
            body: "Please try again. If this occur keeps occurring, please contact European Broker Meeting",
            timeoutInMS: 5000,
          })
        } else {
          eventBus.$emit("createSnackbar", {
            type: "success",
            title: "Meeting request reminder was successfully sent",
          })
        }

        await this.reload()
        this.showSendReminder = false
      } catch (error) {
        console.log("Error sending reminder")
      }
    },
    async refetchNotes(scheduleId, clearNotesFirst = true) {
      if (clearNotesFirst) {
        this.notes = []
      }
      const res = await this.getNotes(scheduleId)
      this.notes = res.data.notes
      this.scrollToBottom()
    },
    async toggleNoteModal(timeslot) {
      this.meetingDetails = {
        timeslot
      }

      this.newNote = ""
      this.loadingNotes = true
      this.showMeetingNotesModal = true

      const meet = this.meetingDetails.timeslot.meet
      const scheduleId = meet.parentScheduleId ?? meet.id

      // await new Promise(resolve => setTimeout(resolve, 2000)); 
      this.refetchNotes(scheduleId)


      await this.$nextTick()
      this.$refs.noteTextarea?.focus()
      this.loadingNotes = false
    },
    async handleAddNote() {
      const meet = this.meetingDetails.timeslot.meet
      const scheduleId = meet.parentScheduleId ?? meet.id
      const payload = {
        scheduleId,
        message: this.newNote,
        createdBy: this.user.id,
        isPrivate: this.isPrivate
      }

      const res = await this.addNote(payload)
      if (res.data.status === 201) {
        eventBus.$emit("createSnackbar", {
          type: "success",
          title: "Note added.",
          timeoutInMS: 5000,
        })

        //Add the note
        this.refetchNotes(scheduleId, false)
      } else {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "There was a problem adding the note.",
          body: "Please try again. If this occur keeps occurring, please contact European Broker Meeting",
          timeoutInMS: 5000,
        })
      }

      // this.showMeetingNotesModal = false;
      this.newNote = "";
      this.$refs.noteTextarea?.focus()
    },
    async handleDeleteNote(noteId) {

      const res = await this.deleteNote(noteId)
      if (res.data.status === 200) {
        eventBus.$emit("createSnackbar", {
          type: "success",
          title: "Note deleted",
          timeoutInMS: 5000,
        })

        // Remove the note
        this.notes = this.notes.filter(n => n.id !== noteId)
      } else {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "There was a problem deleting the note.",
          body: "Please try again. If this occur keeps occurring, please contact European Broker Meeting",
          timeoutInMS: 5000,
        })
      }
    },
    async toggleColleagueModal(timeslot) {
      this.meetingDetails = {
        timeslot
      }

      this.loadingColleagues = true
      this.showColleagueModal = true;
      const timeslotId = this.meetingDetails.timeslot.id

      const res = await this.getAvailableColleague(timeslotId)
      const data = res.data;
      this.loadingColleagues = false

      if (data.status === 200) {
        this.availableColleagues = data.availableColleagues;
        _.each(this.availableColleagues, colleague => {
          if (!colleague.profilePic || colleague.profilePic.length < 5)
            colleague.profilePic = 'https://ui-avatars.com/api/?name=' + encodeURIComponent(colleague.name) + '&background=fff&color=aaa'
        })
      }
    },
    async handleAddColleague(colleagueId, colleagueName) {
      // alert(colleagueId)
      this.disableAddColleagueButton = true
      const payload = {
        meetingId: this.meetingDetails.timeslot.meet.id,
        contactId: colleagueId,
        timeslotId: this.meetingDetails.timeslot.id
      }

      const res = await this.addColleague(payload)
      this.disableAddColleagueButton = false

      if (res.data.status === 200) {
        eventBus.$emit("createSnackbar", {
          type: "success",
          title: `${colleagueName} had been added to the meeting`,
          timeoutInMS: 5000,
        })

        // Remove the colleague from the list of available colleagues
        this.availableColleagues = this.availableColleagues.filter(c => c.id !== colleagueId)
        this.reload();

      } else {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: `There was a problem adding ${colleagueName} to the meeting`,
          body: "Please try again. If this occur keeps occurring, please contact European Broker Meeting",
          timeoutInMS: 5000,
        })
      }

    },
    async handleCanNotAttend() {
      const payload = {
        meetingId: this.meetingDetails.timeslot.meet.id
      }

      const res = await this.canAttendtheMeeting(payload)
      if (res.data.status === 200) {
        eventBus.$emit("createSnackbar", {
          type: "success",
          title: "Meeting has been removed",
          timeoutInMS: 5000,
        })
      } else {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "There was a problem removing the meeting.",
          body: "Please try again. If this occur keeps occurring, please contact European Broker Meeting",
          timeoutInMS: 5000,
        })
      }

      this.showCanNotAttendModal = false
      this.reload()
    },
    async handleRemoveColleague(contactId) {
      const payload = {
        meetingId: this.meetingDetails.timeslot.meet.id,
        contactId
      }
      const res = await this.removeColleague(payload)
      if (res.data.status === 200) {
        eventBus.$emit("createSnackbar", {
          type: "success",
          title: "Colleague has been removed",
          timeoutInMS: 5000,
        })
      } else {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "There was a problem removing your colleague.",
          body: "Please try again. If this occur keeps occurring, please contact European Broker Meeting",
          timeoutInMS: 5000,
        })
      }
      this.reload()
      this.showAttendeeModal = false
    },
    async setAttendeeCount() {
      const attendeeData = JSON.parse(localStorage.getItem('attendeeData'));
      const now = Date.now();

      if (attendeeData && now < attendeeData.validUntil) {
        this.attendeeCount = attendeeData.count
      }
      else {
        const res = await this.getAttendeeCount();

        if (res.data.count) {
          const count = res.data.count;

          // Set expiration time: 10 mins if count > 1, otherwise 1 min
          const ttl = count > 1 ? 10 * 60 * 1000 : 1 * 60 * 1000; // in ms

          const newData = {
            count,
            validUntil: now + ttl
          };

          localStorage.setItem('attendeeData', JSON.stringify(newData));
          this.attendeeCount = count
        }
      }
    },
    async getTechTalks() {
      const res = await this.$http.get("/api/techtalks");
      if (res.data && res.data.techtalks) {
        this.techtalks = res.data.techtalks;
      }
      if (res.data && res.data.speakers) {
        this.speakers = res.data.speakers;
      }
    },
    async fetchCaptainsLunchSlotsTaken() {
      try {
        const res = await this.$http.get("/api/misc/captLunchSlotsTaken");
        if (res.data.status === 200) {
          const data = res.data
          // this.captainsDinnerRegistrationStatus = data.registrationStatus
          this.captainsDinnerRegistrationStatus = false // set to disabled for now
        }
      } catch (err) {
        console.log("err", err)
      }
    },

    tabClass(index) {
      // console.log(this.currentTab)
      this.currentTab = String(this.currentTab) // Added by Brian: convert to string, because when using mobile, the value is passed as an integer and the === won't work, results in only displaying the cancelled meetings tab
      if (+index === +this.currentTab) return 'border-red-500 text-red-600 flex whitespace-nowrap border-b-2 py-4 px-1 font-medium'
      window.history.pushState({}, '', `/scheduler?cd=${this.currentTab}`) // added this so that if a tab is clicked, the URL changes as well and doesn't get stuck on a specific when the page is reloaded
      return 'border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700 flex whitespace-nowrap border-b-2 py-4 px-1font-medium'
    },
    autoResize() {
      const textarea = this.$refs.noteTextarea;
      if (textarea) {
        textarea.style.height = 'auto'; // reset height
        textarea.style.height = Math.min(textarea.scrollHeight, 128) + 'px'; // max ~4 lines (4 * 32px)
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.notesContainer;
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },
    formatDay(dateStr, type) { // added by Brian to format the date in the scheduler tabs
      const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

      const dateObj = new Date(dateStr)
      const day = daysOfWeek[dateObj.getDay()]
      const month = months[dateObj.getMonth()]
      const date = dateObj.getDate()

      return `${day} ${month} ${date}`
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      return `${day}/${month}/${year} at ${hours}:${minutes}`
    },
    getMeetingDayDetails(timeslotId, isShort = false) {
      for (const day in this.timeslotsByDay) {
        const timeslot = this.timeslotsByDay[day].find(slot => slot.id === timeslotId)
        if (timeslot) {
          const dayName = timeslot.day === 1 ? 'Thu Oct 22' : 'Fri Oct 23'

          if (isShort) { return `${dayName} ${timeslot.timeStart} - ${timeslot.timeEnd}` }

          return `${dayName} from ${timeslot.timeStart} - ${timeslot.timeEnd}`
        }
      }
      return null // Return null if no timeslot is found
    },
    createMeetingRequest(timeslot) {
      this.$store.dispatch('updateTimeslotRequest', timeslot).then(() => {
        this.$router.push('/Attendees')
      });
    },
    confirmDeleteRequest(timeslot, delAction) {
      this.meetingDetails = {
        timeslot,
        delAction,
      }
      delAction === 'cancel' ? this.showConfirmDeleteRequest = true : this.showConfirmDeclineRequest = true
    },
    confirmAcceptRequest(timeslot) {
      this.meetingDetails = {
        timeslot,
        delAction: 'accept',
      }
      this.showConfirmAcceptRequest = true
    },
    confirmDeleteMeeting(timeslot) {
      this.meetingDetails = {
        timeslot,
        delAction: 'delete',
      }
      this.showConfirmDeleteMeeting = true
    },
    confirmSendReminder(timeslot) {
      this.meetingDetails = {
        timeslot,
        delAction: 'delete',
      }
      this.showSendReminder = true
    },
    showCanNotAttendButton(timeslot) {
      const meet = timeslot.meet
      return meet.parentScheduleId && meet.fromId === this.user.id
    },
    toggleCanNotAttend(timeslot) {
      this.meetingDetails = {
        timeslot
      }
      this.showCanNotAttendModal = true
    },
    toggleAttendeeModal(timeslot) {
      this.meetingDetails = {
        timeslot
      }
      this.showAttendeeModal = true
    },
    displayRemoveButton(contactId, companyId) {
      const { meet } = this.meetingDetails.timeslot;
      return contactId !== meet.fromId &&
        contactId !== meet.toId &&
        this.user.companyId === companyId &&
        !meet.parentScheduleId;
    },
    showAddColleagueButton(meeting) {
      return meeting.status === 1 && !meeting.parentScheduleId && this.attendeeCount > 1
    },
    showCancelMeetingButton(meeting) {
      return meeting.status === 1 && !meeting.parentScheduleId
    },
    formatWebsiteUrl(url) {
      if (!url) return '#';
      if (!/^https?:\/\//i.test(url)) {
        return 'https://' + url;
      }
      return url;
    },
    goToChat(id) {
      const url = this.$router.resolve({ path: '/messages', query: { contact: id } }).href;
      window.open(url, '_blank');
    },
    checkIfTechTalk(timeslotId) {
      return this.techtalks.some(talk => talk.timeSlotId === timeslotId);
    },
    getTechTalkSpeakers(timeslotId) {
      const techTalk = this.techtalks.find(talk => talk.timeSlotId === timeslotId);
      if (!techTalk) return [];

      const speakerIds = techTalk.speakers.split(',').map(id => parseInt(id));
      return this.speakers.filter(speaker => speakerIds.includes(speaker.id));
    },
    openTechTalkInNewWindow() {
      const url = this.$router.resolve({ path: '/techtalk' }).href;
      window.open(url, '_blank');
    },
    showTechtalkDetails(timeslot) {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        return;
      }
      this.showTechTalkDetailsModal = true;
      this.activeTimeslot = timeslot;
      this.techtalkDetails = this.getTechTalk(timeslot);
    },
    async exportMeetings() {
      await this.$http.post("/api/scheduler/export-meeting-schedules", {}, {
          responseType: "blob"
      }).then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", "meeting-schedules.xlsx");

          document.body.appendChild(link);
          link.click();

          link.remove();
          window.URL.revokeObjectURL(url);
      });
    }
    
  },

};
</script>
<style scoped>
.schedule-header {
  margin-top: -1px;
  margin-left: -1px;
  margin-right: -1px;
}
</style>
